import { useQuery } from '@tanstack/react-query'
import { GETMarketplacePreviewItems } from '../requests'
import { MARKETPLACE_PREVIEW_QUERY_KEYS } from './keys'

export type MarketplacePreviewItemsParams = {
  perPage: number
  page: number
  search: string
}

export const useMarketplacePreviewItems = (
  params: MarketplacePreviewItemsParams
) => {
  return useQuery({
    queryKey: [MARKETPLACE_PREVIEW_QUERY_KEYS.items(params)],
    queryFn: () => GETMarketplacePreviewItems(params),
  })
}
